export const useEvent = () => {
    const delay = (wait) => new Promise(resolve => setTimeout(resolve, wait));
    const copyToClipboard = (text) => {
        // Create a temporary textarea element and set its text content to the desired copy value
        const textarea = document.createElement('textarea');
        textarea.value = text;
        // Append the textarea to the DOM
        document.body.appendChild(textarea);
        // Select the contents of the textarea
        textarea.select();
        // Copy the selected text to the clipboard using the Clipboard API
        // Note: This API may not be supported by some browsers and requires user permission
        navigator.clipboard.writeText(text);
        // Remove the temporary textarea from the DOM
        document.body.removeChild(textarea);
    };
    return {
        delay,
        copyToClipboard,
    };
};
